(function() {
  /*
  Custom Product Swatches
  - Products must have a "Color" variant with a single color option, e.g. "Forest Green" (variant option order does not matter)
  - Related products are pulled from product metafields and available in the "this.data" object
  - For better usability, each product must have the same list of products as its related colorways, and in the same order
  - To add a new product swatch, please refer to https://fluorescent.co/help/stiletto/faq#variant-color-swatches. 
  */
  class CustomProductSwatches {
    constructor(element) {
      this.container = element;
      this.selectors = {
        data: "[data-colorway-products]",
        links: "[data-colorway-product]"
      }
      this.links = this.container.querySelectorAll(this.selectors.links);

      this.variantOptionsToCheck = ["size", "length"];

      this.init();
      this.bindEvents();
    }

    init() {
      if (document.querySelector(this.selectors.data)) {
        this.data = JSON.parse(document.querySelector(this.selectors.data).innerHTML);
        this.onLoad();
      }
    }

    bindEvents() {
      document.addEventListener("product:variant-change", (e) => this.onVariantChange(e));
    }

    onLoad() {
      const baseHandle = this.container.getAttribute("data-product-handle");
      const baseVariantId = parseInt(this.container.getAttribute("data-variant-id"), 10);
      const productData = this.data.find(el => el.handle === baseHandle);
      const variant = productData.variants.find(el => el.id === baseVariantId);

      this.updateLinks(variant);
    }

    onVariantChange(e) {
      const variantData = e.detail.variant;
      let variant;

      this.data.forEach((product) => {
        variant = product.variants.find(el => el.id === variantData.id);
        if (variant) {
          this.updateLinks(variant);
          return;
        };
      });
    }

    updateLinks(variant) {
      this.links.forEach((el) => {
        const handle = el.getAttribute("data-colorway-product");
        const targetProductData = this.data.find(el => el.handle === handle);

        let targetVariant;
        let fallbackVariant;

        // If only checking for one variant type
        if (this.variantOptionsToCheck.length === 1) { 
          const selectedVariantValue = variant.options[this.variantOptionsToCheck[0]];
          targetProductData.variants.forEach((el) => {
            const targetVariantValue = el.options[this.variantOptionsToCheck[0]];
            if (targetVariantValue === selectedVariantValue) {
              if (el.available) {
                targetVariant = el;
                return;
              }
            }
          });
        }

        // If checking for multiple variant types
        if (this.variantOptionsToCheck.length === 2) {
          targetVariant = targetProductData.variants.find(el => el.options[this.variantOptionsToCheck[0]] === variant.options[this.variantOptionsToCheck[0]] && el.options[this.variantOptionsToCheck[1]] === variant.options[this.variantOptionsToCheck[1]]);

          // If there's no match, at least check for a fallback (first option in variantOptionsToCheck array)
          if (!targetVariant) {
            fallbackVariant = targetProductData.variants.find(el => el.options[this.variantOptionsToCheck[0]] === variant.options[this.variantOptionsToCheck[0]]);
          }
        }

        // If there's an exact variant match, update the swatch URL
        // Else update the swatch URL to the fallback (first option in variantOptionsToCheck array)
        if (targetVariant) {
          el.href = targetVariant.url;
        } else {
          if (fallbackVariant) el.href = fallbackVariant.url;
        }

        // Crossed-out swatch if variant not available
        if (targetVariant && targetVariant.available) {
          el.classList.remove("product__colorways-link--disabled");
        } else {
          el.classList.remove("product__colorways-link--disabled");
        }        
      });
    }
  }

  const customProductSwatches = document.querySelector("[data-custom-product-swatches]");
  if (customProductSwatches) new CustomProductSwatches(customProductSwatches);

})();

//----Footer button animations
//HTML Elements
const menus = document.getElementsByClassName("footer__header--button");
const menuContainers = document.getElementsByClassName('footer__group-content')
//Functions
const togglePaddingBottom = function (el) {
  if(!el.style.paddingBottom){
    el.style.paddingBottom = '0px';
  }else{
    el.style.paddingBottom = '';
  }
}
const toggleIconClass = function (el) {
  el.classList.toggle('open');
}
const addClassOnce =(el) => {
    const menuContent = el.nextElementSibling.firstElementChild;
    menuContent.classList.add('footer__links__animation--open');
}
const changeClass = (el) => {
    const menuContent = el.nextElementSibling.firstElementChild;
    menuContent.classList.toggle('footer__links__animation--open');
    menuContent.classList.toggle('footer__links__animation--close');
}
//Handlers
const handlerClickMenuOnce = function () {
    addClassOnce(this);
    togglePaddingBottom(this.nextElementSibling);
    toggleIconClass(this);
}
const handlerClickMenu = function () {
    let clickCounter = Number(this.getAttribute('data-click-counter'));
    if(clickCounter !== 0){
      toggleIconClass(this);
      togglePaddingBottom(this.nextElementSibling);
      return changeClass(this);
    }
    clickCounter++;
    this.setAttribute('data-click-counter',clickCounter)
}
//Applying code
for (let i = 1; i < menuContainers.length; i++) {
  const menuContainer = menuContainers[i];
  togglePaddingBottom(menuContainer)
}
for (const menu of menus) {
  menu.addEventListener('click', handlerClickMenuOnce, {once:true});
  menu.addEventListener('click', handlerClickMenu);
}
//----Header partial border hover
//HTML Elements
const partialBorder = document.querySelector('#arqd-ajom-header__partial-border');
const urlStartIndex = window.location.href.lastIndexOf('/');
const currentPage = window.location.href.slice(urlStartIndex);
//Applying code
if(currentPage !== '/'){
  partialBorder.classList.toggle('no-transparent');
}